import { ActionIcon, Group } from '@mantine/core';
import { IconLayoutSidebarLeftCollapse } from '@tabler/icons-react';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useLkLayoutStore } from 'stores/local/layout/LkLayoutStore';

import { IconWithTitle } from '../IconWithTitle';

import s from './Header.module.scss';

export const Header: React.FC = () => {
  const { menu } = useLkLayoutStore();

  return (
    <Group justify="space-between" wrap="nowrap" className={s.root}>
      {menu.isOpen && <IconWithTitle />}
      <ActionIcon variant="transparent" color="gray.6" data-sidebar-toggle onClick={menu.toggle}>
        <IconLayoutSidebarLeftCollapse
          className={cn(s.root__collapse, menu.isOpen && s.root__collapse_open)}
          size={20}
        />
      </ActionIcon>
    </Group>
  );
};

export default observer(Header);
